// =================================================================
// 1. 变量定义与初始化
// =================================================================
gsap.registerPlugin(ScrollTrigger, DrawSVGPlugin, SplitText, ScrollToPlugin, ScrollSmoother);

const circle1 = document.querySelector('#circle1');
const circle2 = document.querySelector('#circle2');
const circle3 = document.querySelector('#circle3');
const circle4 = document.querySelector('#circle4');
const textContainer = document.querySelector(".text-container");
const cards = document.querySelectorAll(".inside-cards-card");
const cardHeight1 = cards[0] ? cards[0].offsetHeight : 150;
const cardHeight2 = cards[1] ? cards[1].offsetHeight : 150;
const cardHeight3 = cards[2] ? cards[2].offsetHeight : 150;
const footerY = parseFloat(window.getComputedStyle(document.querySelector('.footer-section-homepage')).height);
const footerSection = document.querySelector('.footer-section-homepage');
const animationScope = document.querySelector('#MainContent') || document.body;

const isMobile = window.matchMedia("(max-aspect-ratio: 1)").matches;
const isTall = window.matchMedia("(min-aspect-ratio: 2/3) and (max-aspect-ratio: 1)").matches;

ScrollTrigger.defaults({ pinSpacing: false });

function updateViewportDimensions() {
    const w = document.documentElement.clientWidth;
    const h = document.documentElement.clientHeight;
    const dw = isTall ? document.documentElement.clientHeight * (2 / 3) : document.documentElement.clientWidth;
    const clipPathRadius = (3 / 5) * Math.sqrt((w ** 2 + h ** 2) / 2);
    const radius = h / w;
    const circleY = (8 * radius - 1.2501) / (16 * radius);
    const circleYPos = circleY * 100 + "%";
    return { w, h, dw, clipPathRadius, radius, circleY, circleYPos };
}

let { w, h, dw, clipPathRadius, radius, circleY, circleYPos } = updateViewportDimensions();

// =================================================================
// 2. 辅助功能函数
// =================================================================

// 音频初始化
function initAudio() {
    const playPauseButton = document.getElementById('playPauseButton');
    const playPauseIcon = document.getElementById('playPauseIcon');
    const waveformBase1 = document.getElementById('waveformBase1');
    const waveformPlayed1 = document.getElementById('waveformPlayed1');
    const waveformBase2 = document.getElementById('waveformBase2');
    const waveformPlayed2 = document.getElementById('waveformPlayed2');
    const mask1 = document.getElementById('mask1');
    const mask2 = document.getElementById('mask2');
    const audioPlayer1 = document.getElementById('audioPlayer1');
    const audioPlayer2 = document.getElementById('audioPlayer2');
    const audioToggle = document.getElementById('audioToggle');
    const othersLabel = document.getElementById('othersLabel');
    const km50Label = document.getElementById('km50Label');
    const quietAudioWrapper = document.querySelector('.quiet-audio-wrapper');

    let isPlaying = false;
    let animationFrameId;
    const waveMaxWidth = document.getElementById('waveformContainer').offsetWidth;

    if (typeof window.assets === 'undefined') {
        console.error('Audio assets not loaded. Check Liquid injection.');
        return;
    }

    audioPlayer2.volume = 0.5;

    function pauseAudio() {
        audioPlayer1.pause();
        audioPlayer2.pause();
        isPlaying = false;
        playPauseIcon.src = window.assets.playIcon;
        cancelAnimationFrame(animationFrameId);
        gsap.set([mask1, mask2], { width: 0 });
    }

    function updateWaveform() {
        if (!isPlaying) {
            cancelAnimationFrame(animationFrameId);
            return;
        }

        const currentAudio = audioToggle.checked ? audioPlayer2 : audioPlayer1;
        const currentMask = audioToggle.checked ? mask2 : mask1;
        const secondaryMask = audioToggle.checked ? mask1 : mask2;

        const duration = isNaN(currentAudio.duration) || currentAudio.duration === 0 ? 1 : currentAudio.duration;
        const progress = currentAudio.currentTime / duration;
        const maskWidth = progress * waveMaxWidth;

        gsap.set(currentMask, { width: maskWidth });

        if (audioToggle.checked) {
            gsap.set(mask1, { width: maskWidth });
            gsap.set(waveformBase1, { opacity: 0.35 });
            gsap.set(waveformPlayed1, { opacity: 0.35 });
        } else {
            gsap.set(waveformBase1, { opacity: 1 });
            gsap.set(waveformPlayed1, { opacity: 1 });
            gsap.set(mask2, { opacity: 1 });
        }

        animationFrameId = requestAnimationFrame(updateWaveform);
    }

    playPauseButton.addEventListener('click', () => {
        const targetAudio = audioToggle.checked ? audioPlayer2 : audioPlayer1;

        if (isPlaying) {
            targetAudio.pause();
            playPauseIcon.src = window.assets.playIcon;
            isPlaying = false;
            cancelAnimationFrame(animationFrameId);
        } else {
            targetAudio.play().catch(error => console.error('Audio play failed', error));
            playPauseIcon.src = window.assets.pauseIcon;
            isPlaying = true;
            updateWaveform();
        }
    });

    audioToggle.addEventListener('change', () => {
        pauseAudio(); 

        if (audioToggle.checked) {
            gsap.set(waveformBase1, { display: 'block', opacity: 0.35 });
            gsap.set(mask1, { display: 'block', opacity: 0.35 });
            gsap.set(waveformBase2, { display: 'block', opacity: 1 });
            gsap.set(mask2, { display: 'block', opacity: 1 });
            othersLabel.classList.remove('active');
            km50Label.classList.add('active');
        } else {
            gsap.set(waveformBase1, { display: 'block', opacity: 1 });
            gsap.set(mask1, { display: 'block', opacity: 1 });
            gsap.set(waveformBase2, { display: 'none', opacity: 1 });
            gsap.set(mask2, { display: 'none', opacity: 1 });
            km50Label.classList.remove('active');
            othersLabel.classList.add('active');
        }
    });

    if (quietAudioWrapper) {
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
                    const computedStyle = window.getComputedStyle(quietAudioWrapper);
                    if (computedStyle.opacity === '0') {
                        pauseAudio();
                    }
                }
            });
        });

        observer.observe(quietAudioWrapper, {
            attributes: true,
            attributeFilter: ['style']
        });
    }
}

// 配件图片轮播初始化
function initAccessoriesImages() {
    const images = gsap.utils.toArray(".att-products-wrapper img");

    gsap.set(images, { opacity: 0, position: "absolute" });
    gsap.set(images[0], { opacity: 1 });

    const tl = gsap.timeline({ repeat: -1 });

    images.forEach((img, index) => {
        tl.set(img, { opacity: 1 })
          .set(img, { opacity: 0, delay: 1 });
    });
}

// DOMContentLoaded 监听
document.addEventListener('DOMContentLoaded', () => {
    initAudio();
    initAccessoriesImages();

    setTimeout(() => {
        animationScope.classList.add('gsap-ready');
    }, 50); 
});

// =================================================================
// 3. GSAP 核心动画逻辑
// =================================================================
document.fonts.ready.then(() => {
    
    // 文本分割处理
    const titleContainers = document.querySelectorAll(".animated-title");
    const titleSplits = [];
    titleContainers.forEach((el) => {
        const split = new SplitText(el, { type: "lines,words", linesClass: "title-line", reduceWhiteSpace: false });
        if(split.words.length > 0) gsap.set(split.words, { y: "110%" });
        titleSplits.push(split.words);
    });

    const textContainers = document.querySelectorAll(".animated-text");
    const textSplits = []; 
    textContainers.forEach((container) => {
        const split = new SplitText(container, { type: "lines" });
        gsap.set(split.lines, { opacity: 0, y: 30 });
        textSplits.push(split.lines);
    });
    
    gsap.set(".logo-domain", { xPercent: -50 });

    /* ==================== 版块 1: Hero 视频 ==================== */
    if (!sessionStorage.getItem('heroAnimationRun')) {

        const heroTl = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            onComplete: () => {
                document.querySelector(".feature-section").style.opacity = "1";
                ScrollTrigger.refresh();
                createFeatureTl();
                sessionStorage.setItem('heroAnimationRun', 'true');
            }
        });

        heroTl
            .from(".pre-logo img", {  autoAlpha: 0, clipPath: isMobile ? "" : "inset(0 0 100% 0)", duration: 0.5 })
            .from(".logo img", {  autoAlpha: 0, clipPath: isMobile ? "" : "inset(0 100% 0 0)", duration: 1 }, 0.5)
            .from(".logo-domain", {  autoAlpha: 0, xPercent: w * isMobile ? -50 : 0, duration: 1 }, 0.5)
            .to(".logo-domain", {
                top: isMobile ? "12px" : "24px",
                width: isMobile ? "" : "228px",
                height: isMobile ? "" : "31.5px",
                scale: isMobile ? "0.525" : "1",
                duration: 2
            }, isMobile ? 0.5 : 1.5)
            .to("#mask-circle", {
                attr: {     
                    cy: "50%",
                    r: "100%"
                },
                duration: 2
            }, isMobile ? 0.5 : 1.5)
            .to(".header", { opacity: 1 }, ">")
            .to(".logo-domain", { display: "none" }, "<")
            .to(".header__heading", { display: "block" }, "<")
            .to(circle1, {
                attr: {
                    rx: isMobile ? () => h * 0.5 : () => w * 0.5,
                    ry: isMobile ? () => h * 0.5 : () => w * 0.5,
                    cx: () => isMobile ? () => h * 0.75 : w * 0.75,
                    cy: () => isMobile ? () => w * 0.2 : h * 0.3
                },
                duration: 3,
            }, isMobile ? 0.5 : 1)
            .to(circle2, {
                attr: {
                    rx: isMobile ? () => h * 0.625 : () => w * 0.625,
                    ry: isMobile ? () => h * 0.625 : () => w * 0.625,
                    cx: isMobile ? () => h * 0.6 : () => w * 0.6,
                    cy: isMobile ? () => w * 0 : () => h * 0
                },
                duration: 3,
            }, isMobile ? 0.5 : 1)
            .to(titleSplits[0], {
                y: "0%",
                stagger: 0.1,
                duration: 1,
                onStart: () => {
                    document.body.style.overflow = 'auto';
                    ({ w, h, dw, clipPathRadius, radius, circleY, circleYPos } = updateViewportDimensions());
                    ScrollTrigger.refresh(); 
                }
            }, isMobile ? 1.5 : 2.5)
            .from([".hero-button", ".scroll-downs"], { opacity: 0, y: isMobile ? "100%" : "200%", duration: 1 }, isMobile ? 1.75 : 3);
    } else {
        gsap.set(".logo-domain", {
            diplay: "none"
        });
        gsap.set(".header", { opacity: 1 });
        gsap.set(".header__heading", { display: "block" });
        gsap.set([".logo img", ".pre-logo img"], {autoAlpha: 1});
        gsap.set("#mask-circle", {
            attr: {     
                cy: "50%",
                r: "100%"
            },
        });

        const heroTl = gsap.timeline({
            defaults: { ease: "power2.inOut" },
            onComplete: () => {
                document.querySelector(".feature-section").style.opacity = "1";
                ScrollTrigger.refresh();
                createFeatureTl();
                sessionStorage.setItem('heroAnimationRun', 'true');
            }
        });

        heroTl
            .to(circle1, {
                attr: {
                    rx: isMobile ? () => h * 0.5 : () => w * 0.5,
                    ry: isMobile ? () => h * 0.5 : () => w * 0.5,
                    cx: () => isMobile ? () => h * 0.75 : w * 0.75,
                    cy: () => isMobile ? () => w * 0.2 : h * 0.3
                },
                duration: 1.5,
            }, 0)
            .to(circle2, {
                attr: {
                    rx: isMobile ? () => h * 0.625 : () => w * 0.625,
                    ry: isMobile ? () => h * 0.625 : () => w * 0.625,
                    cx: isMobile ? () => h * 0.6 : () => w * 0.6,
                    cy: isMobile ? () => w * 0 : () => h * 0
                },
                duration: 1,
            }, 0)
            .to(titleSplits[0], {
                y: "0%",
                stagger: 0.1,
                duration: 1.5,
                onStart: () => {
                    document.body.style.overflow = 'auto';
                    ({ w, h, dw, clipPathRadius, radius, circleY, circleYPos } = updateViewportDimensions());
                    ScrollTrigger.refresh(); 
                }
            }, 0.5)
            .from([".hero-button", ".scroll-downs"], { opacity: 0, y: isMobile ? "100%" : "200%", duration: 1 }, 1);
    }      

    /* ==================== 版块 2: 产品特点 (Feature) ==================== */
    function createFeatureTl() {
        const featureTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".feature-title-wrapper",
                start: "top top",
                end: "bottom top",
                scrub: 1,
                pin: true,
                defaults: { ease: "power2.inOut", duration: 2 },
            }
        });

        featureTl
            .to(titleSplits[0], {
                opacity: 0,
                stagger: 0.2,
                duration: 1
            })
            .to([".hero-button", ".scroll-downs"], { opacity: 0, duration: 1 }, ">-=1")
            .to("#feature-circle", { cy: "50%", r: "100%", duration: 3 }, 0.5)
            .to(".hero-section", { zIndex: "auto", duration: 1 }, "<")
            .to(".feature-section", { 
                backgroundColor: "#000",   
                onStart: () => { 
                    document.querySelector('.hero-section video').pause(); 
                },                              
                onReverseComplete: () => { 
                    document.querySelector('.hero-section video').play(); 
                },
                duration: 2
            }, ">")
            .to(".circle-section", { zIndex: 1, duration: 2 }, "<")
            .to([circle1, circle2], {
                attr: {
                    rx: isMobile ? () => h * 73 / 480 : () => w * 73 / 480,
                    ry: isMobile ? () => h * 73 / 480 : () => w * 73 / 480,
                    cx: () => w * 0.5,
                    cy: () => h * 0.5
                },
                duration: 1
            }, 0.5)
            .to([...titleSplits[1], ...titleSplits[2]], {
                y: "0%",
                stagger: 0.2,
                duration: 1
            }, 2)
            .to(circle1, {
                attr: {
                    rx: isMobile ? () => h * 0.275 : () => w * 73 / 480,
                    ry: isMobile ? () => h * 0.275 : () => w * 73 / 480,
                    cy: isMobile ? () => h * 1.0 : () => h * 1.0
                },
                duration: 2
            }, 1.5)
            .to(circle2, {
                attr: {
                    rx: isMobile ? () => h * 0.75 : () => w * 0.4,
                    ry: isMobile ? () => h * 0.75 : () => w * 0.4,
                    cy: isMobile ? () => h * 1.0 : () => h * 1.0
                },
                duration: 2
            }, 1.5)
            .to([...titleSplits[1], ...titleSplits[2]], {
                opacity: 0,
                stagger: 0.1,
                duration: 1
            }, 5)

        const circleSpacerTl = gsap.timeline({
            scrollTrigger: {
                trigger: ".feature-spacer",
                start: "top top",
                end: "bottom 50%",
                scrub: 0
            }
        });

        circleSpacerTl.to([circle1, circle2], {
            attr: {
                rx: isMobile ? () => dw * 0.44 : () => w * 90 / 480,
                ry: isMobile ? () => dw * 0.44 : () => w * 90 / 480,
                cy: () => h * 0.5
            },
        });
    }

    Promise.all([
        fetch(window.assets.svg1).then(response => response.text()),  
        fetch(window.assets.svg2).then(response => response.text())
    ]).then(([svg1Text, svg2Text]) => {
        document.getElementById("svg1-container").innerHTML = svg1Text;
        document.getElementById("svg2-container").innerHTML = svg2Text;
        ScrollTrigger.refresh();

        gsap.matchMedia().add(
        {
            isDesktop: "(min-aspect-ratio: 1/1)", 
            isNotDesktop: "(max-aspect-ratio: 1/1)"   
        },
        (context) => {
            const { isDesktop, isNotDesktop } = context.conditions;  
            ScrollTrigger.normalizeScroll(true);

            const mainTl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".feature-animation-wrapper",
                    start: "top 50%",
                    end: "+=2000%",
                    scrub: isNotDesktop ? 0.5 : 1,
                    pin: true,
                    defaults: { ease: "power2.inOut", duration: 2 },
                }
            });

            // 卡片点击交互
            const cardScrollTimes = isNotDesktop ? [15, 17, 19] : [18, 20, 22];
            cards.forEach((card, index) => {
                card.style.cursor = "pointer";
                card.addEventListener("click", () => {
                    const scrollTrigger = mainTl.scrollTrigger;
                    const progress = cardScrollTimes[index] / mainTl.duration();
                    const scrollPosition = scrollTrigger.start + (scrollTrigger.end - scrollTrigger.start) * progress;

                    gsap.to(window, {
                        scrollTo: { y: scrollPosition, autoKill: false },
                        ease: "power2.inOut"
                    });
                });
            });

            // 配件点击交互
            const timelinePoints = [43, 46, 49, 52];

            let attY, attX;

            if (isNotDesktop) {
                attY = 0.3 * dw;  
                attX = -h * 0.5 + dw * 0.125; 
            } else {
                attY = h * 0.5 + w * 0.125;
                if (attY > w * 0.5) {
                    attX = 0.25 * w;
                } else {
                    attX = 0.5 * (w * 0.5 - Math.sqrt(0.25 * w * w - attY * attY)); 
                }      
            }

            function animateItem(itemIndex, startTime) {
                const item = `#att-item${itemIndex}`;
                const icon = `#att-icon${itemIndex}`;
                const video = `#att-video${itemIndex}`;
                const image = `#att-image${itemIndex}`;

                mainTl
                    .to(item, { color: "white", duration: 2 }, startTime)
                    .to(icon, { opacity: 1, duration: 2 }, "<")
                    .from(video, { opacity: 0, x: attX, y: attY, duration: 2 }, "<")
                    .from(image, { opacity: 0, duration: 2 }, "<"); 

                if (itemIndex < 4) {
                    mainTl
                        .to(item, { color: "var(--km-white-20)", duration: 2 }, startTime + 3)
                        .to(icon, { opacity: 0, duration: 2 }, "<")
                        .to(video, { opacity: 0, x: isNotDesktop ? -attX : attX, y: isNotDesktop ? attY : -attY, duration: 2 }, "<")
                        .to(image, { opacity: 0, duration: 2 }, "<"); 
                }
            }

                timelinePoints.forEach((time, index) => {
                    animateItem(index + 1, time);
                });

                const animationEndPoints = timelinePoints.map((startTime, index) => {
                    const itemIndex = index + 1;
                    return startTime + 5;
                });

                const leftItems = document.querySelectorAll('.att-left-item');
                leftItems.forEach((item, index) => {
                    item.addEventListener('click', () => {
                        const targetTime = animationEndPoints[index];
                        mainTl.seek(targetTime - 2);
                    });
            });

            /* ==================== 移动端动画流 ==================== */
            if (isNotDesktop) {
                mainTl
                    .to(["#svg1-container path", "#svg1-container circle"], { drawSVG: "0%", duration: 1.5 }, 0.5)
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.375,
                            ry: () => dw * 0.08,
                            cy: () => h * 0.5 + dw * 0.225
                        },
                        duration: 1.5
                    }, "<+=1")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.48,
                            ry: () => dw * 0.12,
                            cy: () => h * 0.5 + dw * 0.245
                        },
                        duration: 1.5
                    }, "<")
                    .fromTo(["#svg2-container circle", "#svg2-container path"], { drawSVG: "0%" }, { drawSVG: "100%", duration: 1.5 }, 2.5)
                    .to("#svg2-container", { opacity: 0, duration: 1 }, ">")
                    .to(".insideOut-img1", { opacity: 1, duration: 1 }, "<")
                    .to(".insideOut-img", { opacity: 0, duration: 1 }, ">")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.45,
                            ry: () => dw * 0.45,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.8,
                            ry: () => dw * 0.8,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(titleSplits[3], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[0], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, 6)
                    .from(".out-button", { opacity: 0, y: "200%", duration: 2 }, "<")
                    .to(titleSplits[3], { opacity: 0, stagger: 0.2, duration: 0.5 }, 9)
                    .to(textSplits[0], { opacity: 0, duration: 2 }, "<")
                    .to(".out-button", { opacity: 0, duration: 2 }, "<")
                    .to(titleSplits[4], { y: "0%", stagger: 0.2, duration: 1, opacity: 1 }, 10)
                    .to(textSplits[1], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .to(".insideOut-img", { y: "-50%", opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.35,
                            ry: () => dw * 0.35,
                            cx: () => w * 0.5,
                            cy: () => h * 0.28
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.625,
                            ry: () => dw * 0.625,
                            cx: () => w * 0.5,
                            cy: () => h * 0.35
                        },
                        duration: 2
                    }, "<")
                    .to(titleSplits[4], { opacity: 0, stagger: 0.2, duration: 0.5 }, ">")
                    .to(textSplits[1], { opacity: 0, duration: 1.5 }, "<")
                    
                    // 卡片切换动画
                    .from(".inside-cards", {
                        y: '100%',
                        opacity: 0,
                        duration: 1
                    }, 13)
                    .to(cards[0].parentNode, { opacity: 1, duration: 1 }, "<")
                    .to(".insideOut-img1", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img2", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.625,
                            ry: () => dw * 0.625,
                            cx: () => w * 0.5,
                            cy: () => h * 0.375                       
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.225,
                            ry: () => dw * 0.225,
                            cx: () => w * 0.6,
                            cy: () => h * 0.225
                        },
                        duration: 2
                    }, "<")
                    .to(".inside-cards", {
                        y: () => - cardHeight1 - w * 0.04,
                        duration: 1
                    }, 15)
                    .to(cards[0].parentNode, { opacity: 0, duration: 1 }, "<")
                    .to(cards[1].parentNode, { opacity: 1, duration: 1 }, "<")
                    .to(".insideOut-img2", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img3", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.225,
                            ry: () => dw * 0.225,
                            cx: () => w * 0.675,
                            cy: () => h * 0.4                      
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.625,
                            ry: () => dw * 0.625,
                            cx: () => w * 0.5,
                            cy: () => h * 0.375 
                        },
                        duration: 2
                    }, "<")
                    .to(".inside-cards", {
                        y: - cardHeight1 - cardHeight2 - w * 0.08,
                        duration: 1
                    }, 17)
                    .to(cards[1].parentNode, { opacity: 0, duration: 1 }, "<")
                    .to(cards[2].parentNode, { opacity: 1, duration: 1 }, "<")
                    .to(".insideOut-img3", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img4", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.625,
                            ry: () => dw * 0.625,
                            cx: () => w * 0.5,
                            cy: () => h * 0.375                    
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.225,
                            ry: () => dw * 0.225,
                            cx: () => w * 0.4,
                            cy: () => h * 0.35 
                        },
                        duration: 2
                    }, "<");

                // 版块 3: 旋钮展示 (Knob)
                mainTl
                    .to([".inside-cards"], { opacity: 0, duration: 1 }, 19)
                    .fromTo(
                        ".insideOut-img4",
                        {
                            clipPath: "circle(80% at 65.3% 24.85%)"
                        },
                        {
                            clipPath: "circle(6% at 65.3% 24.85%)",
                            duration: 1.5
                        }, "<")
                    .to([circle1, circle2], {
                        attr: {
                            rx: () => dw * 0.05,
                            ry: () => dw * 0.05,
                            cx: () => w * 0.5 + dw * 0.102,
                            cy: () => h * 0.5 - dw * 0.502,
                        },
                        duration: 1.5
                    }, "<")
                    .to(".insideOut-img4", { opacity: 0, duration: 0.5 }, 21)
                    .to(".knob-img", { opacity: 1, duration: 0.5 }, "<")
                    .to(".knob-section", { zIndex: 15, duration: 0.5 }, "<")
                    .fromTo(
                        ".knob-img",
                        {
                            clipPath: `circle(0% at 50% 50%)`,
                        },
                        {
                            clipPath: `circle(50% at 50% 50%)`,
                            duration: 2,
                        },
                        21.5
                    )
                    .to(circle1, {
                        attr: {
                            rx: () => h * 0.5 + 1,
                            ry: () => h * 0.5 + 1,
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => h * 0.625,
                            ry: () => h * 0.625,
                            cx: () => h * 0.25,
                            cy: () => h * 0.25
                        },
                        duration: 2
                    }, "<")
                    .to(titleSplits[5], { y: "0%", stagger: 0.2, duration: 1 }, 23.5)
                    .to(textSplits[2], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=0.5")
                    .from(".knob-button", { opacity: 0, y: "200%", duration: 2 }, "<")
                    .from(".knob-video-wrapper", { scale: 0.0001, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[5], { opacity: 0, stagger: 0.2, duration: 0.5 }, 28)
                    .to(".knob-video", { opacity: 0, duration: 0.5 }, "<")
                    .to(textSplits[2], { opacity: 0, duration: 2 }, "<")
                    .to(".knob-button", { opacity: 0, duration: 2 }, "<")
                    .to(".knob-img", { clipPath: `circle(0% at 50% 50%)` }, "<")
                    .to([circle1, circle2], {
                        attr: {
                            rx: () => w * 0.1,
                            ry: () => w * 0.1,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5,
                        },
                        onStart: () => { 
                            document.querySelector('.knob-section video').pause(); 
                        },                              
                        onReverseComplete: () => { 
                            document.querySelector('.knob-section video').play(); 
                        },                        
                        duration: 2
                    }, "<");
                
                // 版块 4: 静音性能 (Quiet)
                mainTl
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.75,
                            ry: () => dw * 0.75,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, 30)
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.4,
                            ry: () => dw * 0.4,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(".quiet-section", { zIndex: 16, duration: 2 }, "<")
                    .to(titleSplits[6], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[3], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".quiet-audio-wrapper", { opacity: 0, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[6], { opacity: 0, stagger: 0.2, duration: 0.5 }, 34)
                    .to(textSplits[3], { opacity: 0, duration: 2 }, "<")
                    .to(".quiet-button", { opacity: 0, duration: 2 }, "<")
                    .to(".quiet-audio-wrapper", { opacity: 0, duration: 2 }, "<+=0.5")
                    .to(circle1, {
                        attr: {
                            rx: () => h * 0.55 - dw * 0.482,
                            ry: () => h * 0.55 - dw * 0.482,
                            cx: () => w * 0.5,
                            cy: () => h * 1.1
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => h * 0.6 - dw * 0.05,
                            ry: () => h * 0.6 - dw * 0.05,
                            cx: () => w * 0,
                            cy: () => h * 1.1
                        },
                        duration: 2
                    }, "<");                
                    
                // 版块 5: 配件丰富 (Attachments)
                mainTl
                    .to(".att-section", { zIndex: 17, duration: 2 }, 37)
                    .to(titleSplits[7], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[4], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".att-button", { opacity: 0, duration: 2 }, "<")
                    .from(".att-products-wrapper", { opacity: 0, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[7], { opacity: 0, stagger: 0.2, duration: 0.5 }, 41)
                    .to(textSplits[4], { opacity: 0, duration: 2 }, "<")
                    .to(".att-button", { opacity: 0, duration: 2 }, "<")
                    .to(".att-products-wrapper", { opacity: 0, duration: 2 }, "<+=0.5")
                    .from(".att-left-panel", { opacity: 0, y: "50%", duration: 2 }, 42)
                    .to([circle1, circle2], {
                        attr: {
                            cx: () => w * 0.5,                        
                            cy: () => h * 1.1,
                        },
                        duration: 1.5
                    }, "<");

                // 版块 6: 关于我们 (About)
                mainTl.to(".att-content-bottom", { opacity: 0, duration: 2 }, 56)
                    .to(".about-section", { zIndex: 18 }, "<+=0.5")
                    .to(".circle-section", { zIndex: 19 }, "<")
                    .to("#about-circle", { cy: "50%", r: "100%", duration: 3 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.75,
                            ry: () => dw * 0.75,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 0.35,
                            ry: () => dw * 0.35,
                            cx: () => w * 0.3,
                            cy: () => h * 0.625
                        },
                        duration: 2
                    }, "<")
                    .to(".about-section", { backgroundColor: "var(--km-secondary)", duration: 2 }, ">")
                    .to(titleSplits[8], { y: "0%", stagger: 0.2, duration: 1 }, 59)
                    .to(textSplits[5], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".about-design-button", { opacity: 0, duration: 2 }, "<")
                    .to(titleSplits[8], { opacity: 0, stagger: 0.2, duration: 0.5 }, 64)
                    .to(textSplits[5], { opacity: 0, duration: 2 }, "<")
                    .to(".about-design-button", { opacity: 0, duration: 2 }, "<")
                    .to(".circle-section", { zIndex: -1 }, "<")
                    .to(".about-img-slider", { x: "-94dw", duration: 2 }, 65)
                    .to(".about-img-slider", { x: "-186vw", duration: 2 }, ">")
                    .to(".about-img-slider", { x: "-278vw", duration: 2 }, ">")
                    .to(".about-img-slider", { x: "-364vw", duration: 2 }, ">")
                    .to(".about-img4", {
                        scale: 2,
                        duration: 2
                    }, ">+=0.5")
                    .to([".about-img1", ".about-img2", ".about-img3"], {
                        x: "-33.33333333vw",
                        duration: 2
                    }, "<")
                    .to(".circle-section", { zIndex: 20 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.75,
                            ry: () => dw * 0.75,
                            cx: () => dw * 1,
                            cy: () => h * 0.3
                        },
                        duration: 2,
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => dw * 1.25,
                            ry: () => dw * 1.25,
                            cx: () => dw * 0.8,
                            cy: () => h * 1.2
                        },
                        duration: 2,
                    }, "<")
                    .to(titleSplits[9], { y: "0%", stagger: 0.2, duration: 1 }, 75)
                    .to(textSplits[6], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".about-sustainability-button", { opacity: 0, duration: 2 }, "<")
                    .to(titleSplits[9], { opacity: 0, stagger: 0.2, duration: 0.5 }, 80)
                    .to(textSplits[6], { opacity: 0, duration: 2 }, "<")
                    .to(".about-sustainability-button", { opacity: 0, duration: 2 }, "<")

                    // 版块 7: 用户分享 (Instagram)
                    .to(".ins-section", { zIndex: 19 }, 81)
                    .to("#ins-circle", { cy: "50%", r: "100%", duration: 3 }, "<")
                    .to([circle1, circle3], {
                        attr: {
                            rx: () => w * 0.9,
                            ry: () => w * 0.9,
                            cx: () => -w * 0.1,
                            cy: () => h * 1
                        },
                        duration: 2
                    }, "<+=1")
                    .to([circle2, circle4], {
                        attr: {
                            rx: () => w * 0.9,
                            ry: () => w * 0.9,
                            cx: () => w * 1,
                            cy: () => h * 0.75
                        },
                        duration: 2
                    }, "<")
                    .to(".ins-section", { backgroundColor: "black", duration: 2 }, "<")
                    .to(titleSplits[10], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[7], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .to(titleSplits[10], { opacity: 0, stagger: 0.2, duration: 0.5 }, 88)
                    .to(textSplits[7], { opacity: 0, duration: 2 }, "<")
                    .to(".circle-section", { zIndex: 1 }, "<")
                    .from(".ins-ani-top", { x: "-100%", duration: 3 }, 90)
                    .from(".ins-ani-bottom", { x: "100%", duration: 3 }, "<")
                    .from(".ins-overlay", { display: "none" }, 93);                   
            } 
            
            /* ==================== 桌面端动画流 ==================== */
            else {
                mainTl
                    .to(["#svg1-container path", "#svg1-container circle"], { drawSVG: "0%", duration: 1.5 }, 0.5)
                    .to(circle1, {
                        attr: {
                            rx: () => w * 90 / 480,
                            ry: () => w * 90 / 2400,
                            cy: () => h * 0.5 + w * 0.1
                        },
                        duration: 1.5
                    }, "<+=1")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 120 / 480,
                            ry: () => w * 130 / 2400,
                            cy: () => h * 0.5 + w * 0.11
                        },
                        duration: 1.5
                    }, "<")
                    .fromTo(["#svg2-container circle", "#svg2-container path"], { drawSVG: "0%" }, { drawSVG: "100%", duration: 1.5 }, 2.5)
                    .to(".feature-content", { x: "-76.5%", duration: 2 }, 5.5)
                    .to("#svg2-container", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img1", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.16,
                            ry: () => w * 0.16,
                            cx: () => w * 0.275,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<+=0.25")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.325,
                            ry: () => w * 0.325,
                            cx: () => w * 0.425,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(titleSplits[3], { y: "0%", stagger: 0.2, duration: 1 }, 5.5)
                    .to(textSplits[0], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, 6)
                    .from(".out-button", { opacity: 0, y: "200%", duration: 2 }, "<")
                    .to(titleSplits[3], { opacity: 0, stagger: 0.2, duration: 0.5 }, 9)
                    .to(textSplits[0], { opacity: 0, duration: 2 }, "<")
                    .to(".out-button", { opacity: 0, duration: 2 }, "<")
                    .to(".insideOut-img", { x: "150%", duration: 2 }, 10)
                    .to(circle1, {
                        attr: {
                            cx: () => w * 0.725
                        },
                        duration: 1.5
                    }, "<+=0.25")
                    .to(circle2, {
                        attr: {
                            cx: () => w * 0.575                          
                        },
                        duration: 1.5
                    }, "<")
                    .to(titleSplits[4], { y: "0%", stagger: 0.2, duration: 1 }, 11)
                    .to(textSplits[1], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, 11.5)
                    .to(titleSplits[4], { opacity: 0, stagger: 0.2, duration: 0.5 }, 14.5)
                    .to(textSplits[1], { opacity: 0, duration: 1.5 }, "<")

                    .to(".inside-cards", {
                        y: () => -(h / 2 + cardHeight1 / 2),
                        duration: 1
                    }, 16)
                    .to(cards[0], { opacity: 1, duration: 1 }, "<")
                    .to(cards[1], { opacity: 0.35, duration: 1 }, "<")
                    .to(cards[2], { opacity: 0.15, duration: 1 }, "<")
                    .to(".insideOut-img1", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img2", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => dw * 0.325,
                            ry: () => dw * 0.325,
                            cx: () => w * 0.575,
                            cy: () => h * 0.5
                        },
                        duration: 1
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.11,
                            ry: () => w * 0.11,
                            cx: () => w * 0.73,
                            cy: () => h * 0.5 - w * 0.075
                        },
                        duration: 1
                    }, "<")

                    .to(".inside-cards", {
                        y: () => -(h / 2 + 24 + cardHeight1 + cardHeight2 / 2),
                        duration: 1
                    }, 18)
                    .to(cards[0], { opacity: 0.35, duration: 1 }, "<")
                    .to(cards[1], { opacity: 1, duration: 1 }, "<")
                    .to(cards[2], { opacity: 0.35, duration: 1 }, "<")
                    .to(".insideOut-img2", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img3", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.11,
                            ry: () => w * 0.11,
                            cx: () => w * 0.76,
                            cy: () => h * 0.5 + w * 0.055
                        },
                        duration: 1
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.325,
                            ry: () => w * 0.325,
                            cx: () => w * 0.575,
                            cy: () => h * 0.5
                        },
                        duration: 1
                    }, "<")

                    .to(".inside-cards", {
                        y: () => -(h / 2 + 48 + cardHeight1 + cardHeight2 + cardHeight3 / 2),
                        duration: 1
                    }, 20)
                    .to(cards[0], { opacity: 0.15, duration: 1 }, "<")
                    .to(cards[1], { opacity: 0.35, duration: 1 }, "<")
                    .to(cards[2], { opacity: 1, duration: 1 }, "<")
                    .from(".inside-button", { opacity: 0, y: "200%", duration: 1 }, "<")
                    .to(".insideOut-img3", { opacity: 0, duration: 1 }, "<")
                    .to(".insideOut-img4", { opacity: 1, duration: 1 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.325,
                            ry: () => w * 0.325,
                            cx: () => w * 0.575,
                            cy: () => h * 0.5
                        },
                        duration: 1
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.11,
                            ry: () => w * 0.11,
                            cx: () => w * 0.67,
                            cy: () => h * 0.5 + w * 0.03
                        },
                        duration: 1
                    }, "<")
                    .to(".inside-cards", {
                        y: () => -(h / 2 + 72 + cardHeight1 + cardHeight2 + cardHeight3 + cardHeight1 / 2),
                        duration: 1
                    }, 22)
                    .to([".inside-cards"], { opacity: 0, duration: 1 }, "<")
                    .fromTo(
                        ".insideOut-img4",
                        {
                            clipPath: "circle(80% at 65.3% 24.85%)"
                        },
                        {
                            clipPath: "circle(1% at 65.3% 24.85%)",
                            duration: 1.5
                        },
                        "<"
                    )
                    .to([circle1, circle2], {
                        attr: {
                            rx: () => w * 0.015,
                            ry: () => w * 0.015,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY,
                        },
                        duration: 1.5
                    }, "<")

                    .to(".insideOut-img4", { opacity: 0, duration: 0.5 }, 23)
                    .to(".knob-img", { opacity: 1, duration: 0.5 }, "<")
                    .to(".knob-section", { zIndex: 15, duration: 0.5 }, "<")
                    .fromTo(
                        ".knob-img",
                        {
                            clipPath: `circle(0% at 77.1875% ${circleYPos})`,
                        },
                        {
                            clipPath: `circle(60% at 77.1875% ${circleYPos})`,
                            duration: 2,
                        },
                        23.5
                    )
                    .to(circle1, {
                        attr: {
                            rx: () => clipPathRadius,
                            ry: () => clipPathRadius,
                            cx: () => w * 0.771875,
                            cy: () => h * circleY
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.625,
                            ry: () => w * 0.625,
                            cx: () => w * 0.6,
                            cy: () => h * 0
                        },
                        duration: 2
                    }, "<")
                    .to(titleSplits[5], { y: "0%", stagger: 0.2, duration: 1 }, 25.5)
                    .to(textSplits[2], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, 26)
                    .from(".knob-button", { opacity: 0, y: "200%", duration: 2 }, "<")
                    .from(".knob-video-wrapper", { scale: 0.0001, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[5], { opacity: 0, stagger: 0.2, duration: 0.5 }, 29)
                    .to(".knob-video", { opacity: 0, duration: 0.5 }, "<")
                    .to(textSplits[2], { opacity: 0, duration: 2 }, "<")
                    .to(".knob-button", { opacity: 0, duration: 2 }, "<")
                    .to(".knob-img", { clipPath: `circle(0% at 77.1875% ${circleYPos})` }, "<")
                    .to([circle1, circle2], {
                        attr: {
                            rx: () => w * 0.1,
                            ry: () => w * 0.1,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5,
                        },
                        onStart: () => { 
                            document.querySelector('.knob-section video').pause(); 
                        },                              
                        onReverseComplete: () => { 
                            document.querySelector('.knob-section video').play(); 
                        },                         
                        duration: 2
                    }, "<")

                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.3,
                            ry: () => w * 0.3,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, 31)
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.15,
                            ry: () => w * 0.15,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },                     
                        duration: 2
                    }, "<")
                    .to(".quiet-section", { zIndex: 16, duration: 2 }, "<")
                    .to(titleSplits[6], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[3], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".quiet-audio-wrapper", { opacity: 0, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[6], { opacity: 0, stagger: 0.2, duration: 0.5 }, 35)
                    .to(textSplits[3], { opacity: 0, duration: 2 }, "<")
                    .to(".quiet-button", { opacity: 0, duration: 2 }, "<")
                    .to(".quiet-audio-wrapper", { opacity: 0, duration: 2 }, "<+=0.5")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.225,
                            ry: () => w * 0.225,
                            cx: () => w * 1.05,
                            cy: () => h * 0.25
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.5,
                            ry: () => w * 0.5,
                            cx: () => w * 1.05,
                            cy: () => h * 1.35
                        },                                                     
                        duration: 2
                    }, "<")

                    .to(".att-section", { zIndex: 17, duration: 2 }, 37)
                    .to(titleSplits[7], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to(textSplits[4], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".att-button", { opacity: 0, duration: 2 }, "<")
                    .from(".att-products-wrapper", { opacity: 0, y: "50%", duration: 2 }, "<")
                    .to(titleSplits[7], { opacity: 0, stagger: 0.2, duration: 0.5 }, 41)
                    .to(textSplits[4], { opacity: 0, duration: 2 }, "<")
                    .to(".att-button", { opacity: 0, duration: 2 }, "<")
                    .to(".att-products-wrapper", { opacity: 0, duration: 2 }, "<+=0.5")
                    .from(".att-left-panel", { opacity: 0, y: "50%", duration: 2 }, 42)
                    .to([circle1, circle2], {
                        attr: {
                            cy: () => h * 0.5,
                        },
                        duration: 1.5
                    }, "<");

                // 版块 6: 关于我们 (About)
                mainTl
                    .to(".att-content-bottom", { opacity: 0, duration: 2 }, 56)
                    .to(".about-section", { zIndex: 18 }, "<+=0.5")
                    .to(".circle-section", { zIndex: 19 }, "<")
                    .to("#about-circle", { cy: "50%", r: "100%", duration: 3 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.3,
                            ry: () => w * 0.3,
                            cx: () => w * 0.5,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.15,
                            ry: () => w * 0.15,
                            cx: () => w * 0.425,
                            cy: () => h * 0.675
                        },
                        duration: 2
                    }, "<")
                    .to(".about-section", { backgroundColor: "var(--km-secondary)", duration: 2 }, ">")
                    .to(titleSplits[8], { y: "0%", stagger: 0.2, duration: 1 }, 59)
                    .to(textSplits[5], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".about-design-button", { opacity: 0, duration: 2 }, "<")
                    .to(titleSplits[8], { opacity: 0, stagger: 0.2, duration: 0.5 }, 64)
                    .to(textSplits[5], { opacity: 0, duration: 2 }, "<")
                    .to(".about-design-button", { opacity: 0, duration: 2 }, "<")
                    .to(".circle-section", { zIndex: -1 }, "<")
                    .to(".about-img-slider", { x: "-68.75vw", duration: 2 }, 65)
                    .to(".about-img-slider", { x: "-137.5vw", duration: 2 }, ">")
                    .to(".about-img-slider", { x: "-206.25vw", duration: 2 }, ">")
                    .to(".about-img-slider", { x: "-272.91666667vw", duration: 2 }, ">")
                    .to(".about-img4", {
                        scale: 1.5,
                        duration: 2
                    }, ">+=0.5")
                    .to([".about-img1", ".about-img2", ".about-img3"], {
                        x: "-33.33333333vw",
                        duration: 2
                    }, "<")
                    .to(".circle-section", { zIndex: 20 }, "<")
                    .to(circle1, {
                        attr: {
                            rx: () => w * 0.45,
                            ry: () => w * 0.45,
                            cx: () => w * 0.75,
                            cy: () => h * 0.3
                        },
                        duration: 2,
                    }, "<")
                    .to(circle2, {
                        attr: {
                            rx: () => w * 0.625,
                            ry: () => w * 0.625,
                            cx: () => w * 0.8,
                            cy: () => h * 1.2
                        },
                        duration: 2,
                    }, "<")
                    .to(titleSplits[9], { y: "0%", stagger: 0.2, duration: 1 }, 75)
                    .to(textSplits[6], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .from(".about-sustainability-button", { opacity: 0, duration: 2 }, "<")
                    .to(titleSplits[9], { opacity: 0, stagger: 0.2, duration: 0.5 }, 80)
                    .to(textSplits[6], { opacity: 0, duration: 2 }, "<")
                    .to(".about-sustainability-button", { opacity: 0, duration: 2 }, "<")

                    // 版块 7: 用户分享 (Instagram)
                    .to(".ins-section", { zIndex: 19 }, 81)
                    .to("#ins-circle", { cy: "50%", r: "100%", duration: 3 }, "<")
                    .to([circle1, circle3], {
                        attr: {
                            rx: () => w * 0.5,
                            ry: () => w * 0.5,
                            cx: () => w * 0.3,
                            cy: () => h * 0.5
                        },
                        duration: 2
                    }, "<+=1")
                    .to([circle2, circle4], {
                        attr: {
                            rx: () => w * 0.6,
                            ry: () => w * 0.6,
                            cx: () => w * 0.9,
                            cy: () => h * 1.5
                        },
                        duration: 2
                    }, "<")
                    .to(".ins-section", { backgroundColor: "black", duration: 2 }, "<")
                    .to(titleSplits[10], { y: "0%", stagger: 0.2, duration: 1 }, "<")
                    .to([".header",".logo-domain"], {display: "none"}, "<")
                    .to(textSplits[7], { opacity: 1, y: 0, duration: 1, stagger: 0.2 }, "<+=2")
                    .to(titleSplits[10], { opacity: 0, stagger: 0.2, duration: 0.5 }, 88)
                    .to(textSplits[7], { opacity: 0, duration: 2 }, "<")
                    .to(".circle-section", { zIndex: 1 }, "<")
                    .from(".ins-ani-top", { y: "-100%", duration: 3 }, 90)
                    .from(".ins-ani-bottom", { y: "100%", duration: 3 }, "<")
                    .from(".ins-overlay", { display: "none" }, 95);
            }

            /* ==================== 版块 8: 页脚 (Footer) ==================== */
            // 预定义圆圈浮动动画
            function getRandomNumber(min, max) {
                return Math.random() * (max - min) + min;
            }

            const randomR1 = isMobile ? getRandomNumber(h * 0.3, h * 0.6) : getRandomNumber(750, 1000);
            const randomR2 = isMobile ? getRandomNumber(h * 0.3, h * 0.6) : getRandomNumber(750, 1000);
            const circle3Anim = gsap.to(circle3, {
                duration: 10,
                attr: {
                    cx: () => isMobile ? getRandomNumber(-w * 0.2, w * 1.2) : getRandomNumber(-200, 2000),
                    cy: () => isMobile ? getRandomNumber(-h * 0.1, h * 1.1) : getRandomNumber(-200, 1000),
                    rx: () => randomR1,
                    ry: () => randomR1
                },
                ease: "none",
                repeat: -1,
                repeatRefresh: true, 
                paused: true 
            });

            const circle4Anim = gsap.to(circle4, {
                duration: 12, 
                attr: {
                    cx: () => isMobile ? getRandomNumber(-w * 0.2, w * 1.2) : getRandomNumber(-200, 2000),
                    cy: () => isMobile ? getRandomNumber(-h * 0.1, h * 1.1) : getRandomNumber(-200, 1000),
                    rx: () => randomR2,
                    ry: () => randomR2
                },
                ease: "none",
                repeat: -1,
                repeatRefresh: true,
                paused: true
            });

            const footerTl = gsap.timeline({
                scrollTrigger: {
                    trigger: ".footer-section-homepage",
                    start: "top 50%",       
                    end: "bottom bottom",   
                    scrub: 1, 
                    onEnter: () => {
                        circle3Anim.play();
                        circle4Anim.play();
                    },
                    onLeaveBack: () => {
                        circle3Anim.pause();
                        circle4Anim.pause();
                    }
                }
            });

            footerTl
                .to(titleSplits[11], { 
                    y: "0%", 
                    stagger: 0.2, 
                    duration: 1 
                })
                .to(textSplits[8], { 
                    opacity: 1, 
                    y: 0, 
                    duration: 1, 
                    stagger: 0.2 
                }, "<+=0.25")
                .from(".footer-subscribe-form", { 
                    y: 60, 
                    opacity: 0, 
                    duration: 2 
                }, "<") 
                .to(".footer-background", {
                    opacity: 1,
                    duration: 1.5,
                }, "<")
                
                .from(".footer-bottom", { 
                    y: 120, 
                    opacity: 0, 
                    duration: 2 
                }, "<+=0.5") 

                .from([".footer-column", ".footer-column-title"], { 
                    y: isMobile ? 10 : 30, 
                    opacity: 0, 
                    duration: 0.6,
                    stagger: 0.1
                }, "-=1.5"); 

            const columns = document.querySelectorAll(".footer-column");
            if (columns.length > 0) {
                const maxItems = Math.max(...Array.from(columns).map(col => col.querySelectorAll("li, .footer-social-icons a").length));

                for (let i = 0; i < maxItems; i++) {
                    const itemsAtIndex = Array.from(columns).map(col => {
                        const items = col.querySelectorAll("li, .footer-social-icons a");
                        return items[i] || null;
                    }).filter(item => item !== null);

                    if (itemsAtIndex.length) {
                        footerTl.from(itemsAtIndex, {
                            y: 30,
                            opacity: 0,
                            duration: 0.6,
                        }, i === 0 ? "<" : "<+=0.1"); 
                    }
                }
            }
        });
    })
});

class CustomButton extends HTMLElement {
    
    constructor() {
        super(); 

        const text = this.getAttribute('text') || 'Learn More';
        const link = this.getAttribute('link') || '#';
        
        // 安全检查：确保 assets 变量已加载
        let iconPath;
        if (typeof window.assets !== 'undefined') {
            iconPath = this.getAttribute('icon-path') || window.assets.buttonIcon;  
        } else {
            console.error('Button icon asset not loaded. Check Liquid injection.');
            iconPath = this.getAttribute('icon-path') || window.assets.buttonIcon;
        }

        this.innerHTML = `
            <a href="${link}" class="custom-button">
                <span class="button-text-container">
                    <span class="button-text-top">${text}</span>
                    <span class="button-text-bottom">${text}</span>
                </span>
                <span class="button-icon">
                    <img src="${iconPath}" alt="Arrow icon">
                </span>
            </a>
        `;
    }
}

customElements.define('custom-button', CustomButton);